export default __webpack_public_path__ + "static/media/myimg.cb9bc3a0.png";